import React from "react";
import { Form, Button } from "react-bootstrap";
import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import "yup-phone";

export default function RegistrationStepThree({
  data,
  incrementStep,
  decrementStep,
}) {
  const validationSchema = Yup.object().shape({
    doctorName: Yup.string().required("Required"),
    doctorAddress1: Yup.string().required("Required"),
    doctorCity: Yup.string().required("Required"),
    doctorPostcode: Yup.string()
      .required("Required")
      .matches(
        "^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$",
        "Invalid Postcode"
      ),
    doctorPhone: Yup.string()
      .matches(/^\d{11}$/, "Only 11 digits allowed")
      .required("Required"),
  });

  return (
    <div className="registration-step-3">
      <h5 className="mb-3">Doctor's Details:</h5>
      <Formik
        initialValues={data}
        validationSchema={validationSchema}
        onSubmit={(values) => incrementStep(values)}
      >
        {({ values, handleChange, handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <div className="d-flex flex-wrap">
              <div className="mb-3 me-md-3 me-0 flex-grow-1">
                <Form.Label>Doctor's Name/Pratice Name</Form.Label>
                <Form.Control
                  type="text"
                  name="doctorName"
                  placeholder="Enter name"
                  value={values.doctorName}
                  onChange={handleChange}
                />
                <ErrorMessage
                  name="doctorName"
                  component="p"
                  className="error-message"
                />
              </div>
              <div className="mb-3 flex-grow-1">
                <Form.Label>Address Line 1</Form.Label>
                <Form.Control
                  type="text"
                  name="doctorAddress1"
                  placeholder="Enter address"
                  value={values.doctorAddress1}
                  onChange={handleChange}
                />
                <ErrorMessage
                  name="doctorAddress1"
                  component="p"
                  className="error-message"
                />
              </div>
            </div>
            <div className="d-flex flex-wrap">
              <div className="mb-3 me-md-3 me-0 flex-grow-1">
                <Form.Label>Address Line 2</Form.Label>
                <Form.Control
                  type="text"
                  name="doctorAddress2"
                  placeholder="Enter address"
                  value={values.doctorAddress2}
                  onChange={handleChange}
                />
                <ErrorMessage
                  name="doctorAddress2"
                  component="p"
                  className="error-message"
                />
              </div>
              <div className="mb-3 flex-grow-1">
                <Form.Label>City</Form.Label>
                <Form.Control
                  type="text"
                  name="doctorCity"
                  placeholder="Enter city"
                  value={values.doctorCity}
                  onChange={handleChange}
                />
                <ErrorMessage
                  name="doctorCity"
                  component="p"
                  className="error-message"
                />
              </div>
            </div>
            <div className="d-flex flex-wrap">
              <div className="mb-3 me-md-3 me-0 flex-grow-1">
                <Form.Label>Postcode</Form.Label>
                <Form.Control
                  type="text"
                  name="doctorPostcode"
                  placeholder="Enter postcode"
                  value={values.doctorPostcode}
                  onChange={handleChange}
                />
                <ErrorMessage
                  name="doctorPostcode"
                  component="p"
                  className="error-message"
                />
              </div>
              <div className="mb-3 flex-grow-1">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="tel"
                  name="doctorPhone"
                  placeholder="Enter phone number"
                  value={values.doctorPhone}
                  onChange={handleChange}
                />
                <ErrorMessage
                  name="doctorPhone"
                  component="p"
                  className="error-message"
                />
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <Button
                variant="primary"
                className="me-2"
                type="button"
                onClick={() => decrementStep(values)}
              >
                Back
              </Button>
              <Button variant="primary" type="submit">
                Next
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}
